module.exports = __webpack_public_path__ + "img/060-alarm-clock.7788998e.svg";